import { ApiIncrementalityTest } from "@incendium/api";
import { useCallback } from "react";
import produce from "immer";
import { useHistory } from "react-router-dom";
import { useSelectedProject } from "Hooks";
import useProtectedRoutes from "Hooks/useProtectedRoutes";
import { RouteNames } from "Hooks/routeNames";
import IncrementalityTestsList from "features/incrementality/components/IncrementalityTestsList";
import { useIncrementalityTests } from "features/incrementality/hooks/useIncrementalityTests";
import { deleteIncrementalityTest } from "features/incrementality/services/incrementalityService";

function IncrementalityTestsPage() {
  const history = useHistory();
  const { selectedClient, selectedProject } = useSelectedProject();
  const { pathByName } = useProtectedRoutes();
  const { tests, setTests } = useIncrementalityTests();

  const onCreate = useCallback(() => {
    history.push(
      pathByName(RouteNames.INCREMENTALITY_SETUP, {
        clientId: selectedClient?.id,
        projectId: selectedProject?.id,
        testId: "new",
      }),
    );
  }, [history, pathByName, selectedClient?.id, selectedProject?.id]);

  const onOpen = useCallback(
    (id: number) => {
      history.push(
        pathByName(RouteNames.INCREMENTALITY_SETUP, {
          clientId: selectedClient?.id,
          projectId: selectedProject?.id,
          testId: id,
        }),
      );
    },
    [history, pathByName, selectedClient?.id, selectedProject?.id],
  );

  const onDelete = useCallback(
    async (test: ApiIncrementalityTest) => {
      if (!selectedProject?.id || !test.id) return "Unable to delete test";
      await deleteIncrementalityTest(selectedProject.id, test.id);
      setTests((prev: ApiIncrementalityTest[]) =>
        produce(prev || [], (draft) => {
          const idx = draft.findIndex((item) => item.id === test.id);
          if (idx >= 0) {
            draft.splice(idx, 1);
          }
        }),
      );
      return "Test Deleted";
    },
    [selectedProject?.id, setTests],
  );

  return (
    <IncrementalityTestsList
      tests={tests}
      onOpen={onOpen}
      onCreate={onCreate}
      onDelete={onDelete}
    />
  );
}

export default IncrementalityTestsPage;
